import { DropdownToggle, DropdownMenu } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledFontAwesome = styled(FontAwesomeIcon)`
  font-size: 12px;
  margin-left: 3px;
  transform: translateY(-1px);
`;

export const StyledDropdownToggle = styled(DropdownToggle)`
  min-width: 155px;
`;

export const StyledDropdownMenu = styled(DropdownMenu)`
  right: 0 !important;
  left: auto !important;
  transform: translate3d(0, 40px, 0px) !important;
`;

export const FileUploadLabel = styled.label`
  position: relative;
  margin: 0;
  padding: 0;
  cursor: pointer;
`;

export const StyledMenuText = styled.span`
  margin-left: 4px;
`;
export const CustomFileInput = styled.input`
  position: absolute;
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
  font-size: 10px;
  height: 25px;
  width: 158px;
  right: 0;
  left: -48px;
  top: 0;
  cursor: pointer;

  &::before {
    color: black;
    content: 'File Upload';
    display: inline-block;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
  }

  &:hover::before {
    border-color: black;
  }

  &:active::before {
    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
  }
`;
